import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function MessagingTerms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <button
          onClick={() => navigate("/")}
          className="mb-6 flex items-center text-sm text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="mr-1 size-4" />
          Back
        </button>

        <div className="mx-auto max-w-3xl rounded-xl border bg-white p-8 shadow-sm">
          <h1 className="mb-6 text-2xl font-bold text-gray-900">
            SMS & WhatsApp Messaging Terms
          </h1>

          <div className="prose prose-sm">
            <h2 className="mb-4 mt-6 text-xl font-semibold">
              SMS Communications
            </h2>
            <p className="mb-4">
              By agreeing to receive SMS messages from Vincer, you understand
              and agree to the following terms:
            </p>

            <ul className="mb-4 list-disc space-y-2 pl-6">
              <li>
                You consent to receive text messages from Vincer at the phone
                number you provided, which may be sent through an automatic
                telephone dialing system.
              </li>
              <li>
                Message frequency varies. You may receive messages related to:
                <ul className="my-2 list-disc pl-6">
                  <li>Appointment reminders and scheduling updates</li>
                  <li>Session confirmations and changes</li>
                  <li>Important program updates and announcements</li>
                  <li>Feedback requests and survey participation</li>
                </ul>
              </li>
              <li>
                Message and data rates may apply. You are responsible for any
                messaging or data charges from your wireless provider.
              </li>
              <li>
                You can opt out of receiving SMS messages at any time by
                replying "STOP" to any message. After you send STOP, we will
                send you a final message to confirm that you have been
                unsubscribed.
              </li>
              <li>
                Reply "HELP" for help or contact us at support@vincer.com for
                assistance.
              </li>
              <li>
                Carriers are not liable for delayed or undelivered messages.
              </li>
            </ul>

            <h2 className="mb-4 mt-6 text-xl font-semibold">
              Important Information
            </h2>
            <ul className="mb-4 list-disc space-y-2 pl-6">
              <li>
                By providing your phone number, you represent that you are the
                account holder or have permission to use this number for SMS
                communications.
              </li>
              <li>
                Text messages may be sent using an automatic telephone dialing
                system or other automated system.
              </li>
              <li>
                Consent to receive SMS messages is not required to use Vincer's
                services. You can choose to opt out of SMS communications while
                continuing to use the platform.
              </li>
              <li>
                We will protect your privacy in accordance with our privacy
                policy and will not share your phone number with third parties
                for their marketing purposes.
              </li>
            </ul>

            <h2 className="mb-4 mt-6 text-xl font-semibold">
              Changes to These Terms
            </h2>
            <p className="mb-4">
              Vincer reserves the right to update or modify these SMS messaging
              terms at any time. We will notify you of any material changes via
              SMS or email. Your continued use of our SMS services after such
              modifications constitutes your acceptance of the updated terms.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
